<template>
    <div>
        <div class="modal-close-btn-point">
            <div class="modal-close-btn-container" v-on:click="$emit('close')">
                <SVGModalClose/>
            </div>
        </div>
        <div class="ap-modal-title-big">
            Изменить категорию
        </div>
        <DataEntryForCategory :buttonName="'Применить'"
                              :dataCategory="dataCategory"
                              :parentHierarchyIds="parentHierarchyIds"
                              @apply="apply"/>
    </div>
</template>

<script>
import DataEntryForCategory from "./DataEntryForCategory";
import SVGModalClose from "../../../SVG/SVGModalClose";

export default {
    name: "ChangeCategory",
    components: {
        DataEntryForCategory,
        SVGModalClose
    },
    props:{
        dataCategory:{
            type: Object
        },
        parentHierarchyIds:{
            type: Array
        }
    },
    methods: {
        async apply(newDataCategory) {
            newDataCategory.category_id = this.dataCategory.id;
            await this.$store.dispatch('adminPanel/categories/SAVE_CATEGORY', newDataCategory);
            this.$emit('close');
        }
    }
}
</script>

<style scoped>

</style>
